// SHOW/HIDE PASSWORD TOGGLE
const passwordFields: NodeListOf<HTMLDivElement> = document.querySelectorAll(
  "div[data-password-input]",
);
passwordFields.forEach((passwordField) => {
  const passwordInput: HTMLInputElement | null = passwordField.querySelector(
    'input[type="password"]',
  );
  const showPasswordElement: HTMLDivElement | null =
    passwordField.querySelector("[data-show-password]");
  const hidePasswordElement: HTMLDivElement | null =
    passwordField.querySelector("[data-hide-password]");

  if (!passwordInput || !showPasswordElement || !hidePasswordElement) return;

  ["click", "keydown"].forEach((event) => {
    showPasswordElement.addEventListener(event, (event) =>
      showPassword(
        event,
        passwordInput,
        showPasswordElement,
        hidePasswordElement,
      ),
    );

    hidePasswordElement.addEventListener(event, (event) =>
      hidePassword(
        event,
        passwordInput,
        showPasswordElement,
        hidePasswordElement,
      ),
    );
  });

  // Helper functions
  function showPassword(
    event: Event,
    passwordInput: HTMLInputElement,
    showPasswordElement: HTMLElement,
    hidePasswordElement: HTMLElement,
  ) {
    if (isValidEvent(event)) {
      event.preventDefault();
      passwordInput.type = "text";
      showPasswordElement.setAttribute("hidden", "");
      hidePasswordElement.removeAttribute("hidden");
      hidePasswordElement.focus();
    }
  }

  function hidePassword(
    event: Event,
    passwordInput: HTMLInputElement,
    showPasswordElement: HTMLElement,
    hidePasswordElement: HTMLElement,
  ) {
    if (isValidEvent(event)) {
      event.preventDefault();
      passwordInput.type = "password";
      hidePasswordElement.setAttribute("hidden", "");
      showPasswordElement.removeAttribute("hidden");
      showPasswordElement.focus();
    }
  }

  function isValidEvent(event: Event): boolean {
    if (event instanceof MouseEvent) {
      return true;
    }
    if (event instanceof KeyboardEvent) {
      return event.code === "Enter" || event.code === "Space";
    }
    return false;
  }
});
